// Animate function
jQuery(function ($) {
  function stepAnimateText(element, animation, delay){
    $(element).css('display', 'block');
    var text = $(element).text();
    var curr = '';

    for (var i=0; i < text.length; i++){
      var character = text.charAt(i);
      $(element).html(curr+'<span class="'+animation+'" style="-webkit-animation-delay: '+i*delay+'s; animation-delay: '+i*delay+'s">'+character +"</span>");
      curr = $(element).html();
    }
  }
  // Init on load
  stepAnimateText('.fade-animation','bounceInDown', 0.1);
})
